import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'shared/components/ui/icon';
import { SideNavigationItem } from 'shared/components/ui/side-navigation-item';
import { version } from 'shared/constants';

import { settingsNavGroups, SettingsSection } from './settings-nav';
import * as Styled from './settings-navigation.style';

const NAV_ICON_SIZE = 16;
const NAV_ICON_STROKE_WIDTH = 1.5;

export type SettingsNavigationProps = {
  activeSection: SettingsSection;
  onSelect: (section: SettingsSection) => void;
};

export const SettingsNavigation: React.FC<SettingsNavigationProps> = ({
  activeSection,
  onSelect,
}) => {
  const { t } = useTranslation();

  return (
    <Styled.Sidebar>
      <Styled.TitleContainer>
        <Typography variant="h5" component="h1">
          {t('forms.user-settings.title')}
        </Typography>
      </Styled.TitleContainer>

      <Styled.Nav>
        {settingsNavGroups.map((group, index) => (
          <Styled.Group key={group.translationLabel ?? `group-${index}`}>
            {!!group.translationLabel && (
              <Styled.GroupHeader>
                {t(group.translationLabel)}
              </Styled.GroupHeader>
            )}

            {group.items.map((item) => {
              const handleSelect = () => onSelect(item.section);

              return (
                <SideNavigationItem
                  key={item.section}
                  label={t(item.translationLabel)}
                  start={
                    <Icon
                      icon={item.icon}
                      size={NAV_ICON_SIZE}
                      strokeWidth={NAV_ICON_STROKE_WIDTH}
                    />
                  }
                  active={item.section === activeSection}
                  onClick={handleSelect}
                />
              );
            })}
          </Styled.Group>
        ))}
      </Styled.Nav>

      <Styled.Footer>
        <Styled.Version variant="overline">{version}</Styled.Version>
      </Styled.Footer>
    </Styled.Sidebar>
  );
};
